/**
 * English source copy for before/after gallery surfaces.
 * Localized PageUi overrides live in src/i18n/content/* and page-meta-translations.
 */
export const galleryCopyEn = {
  eyebrow: "Before & After",
  title: "Before-and-after roofing across Metro Vancouver",
  body: "Explore Revolin Roofing before-and-after galleries for Metro Vancouver and Lower Mainland homeowners: from emergency leak repairs to asphalt, metal, cedar, and flat-roof replacements, each with clear problem, diagnosis, and finished-roof context.",
  notice:
    "Filter by service, roof type, or city to find the transformation closest to your home, then request a roof assessment for guidance tailored to your property.",
  projectHeroBody:
    "Explore Revolin Roofing before-and-after transformations across Metro Vancouver: from emergency leak repairs to full asphalt, metal, cedar, and flat-roof replacements. Each gallery highlights the problem, diagnosis, and finished roofing outcome homeowners in the Lower Mainland face.",
  metaTitle: "Before & After Roofing Gallery | Revolin Roofing",
  metaDescription:
    "Explore Revolin Roofing before-and-after galleries across Metro Vancouver: leak repair, asphalt, metal, cedar, and flat-roof transformations for Lower Mainland homeowners.",
  homepageBody:
    "Drag the handle to compare before-and-after roofing transformations for Metro Vancouver homes.",
} as const;
